import React, {Component} from 'react';
import PropTypes from 'prop-types';
import NotificationSystem from 'react-notification-system';
import {setupNotificationSystem} from './notifications';
import {Route} from 'react-router-dom'
import Landing from './components/Landing';
import Login from './containers/Login';
import Logout from './containers/Logout';
import About from './components/About';
import Support from './components/Support';
import TermsOfService from './components/TermsOfService';
import PrivacyPolicy from './components/PrivacyPolicy';
import Contacts from './components/Contacts';
import PresetsContainer from './containers/PresetsContainer';
import PresetEditContainer from './containers/PresetEditContainer';
import SiteFooter from './components/SiteFooter';
import startsWith from 'lodash/startsWith'
import DemoGalleryContainer from './containers/DemoGalleryContainer';
import DemoImageViewerContainer from './containers/DemoImageViewerContainer';
import WorkspaceContainer from './containers/WorkspaceContainer';
import MyImagesContainer from './containers/MyImagesContainer';
import PrivateRoute from './containers/PrivateRoute';
import ProfileContainer from './containers/ProfileContainer';
import UsersContainer from './containers/UsersContainer';
import UserEditContainer from './containers/UserEditContainer';
import RegisterContainer from './containers/RegistrationContainer';
import ResetPasswordContainer from './containers/ResetPasswordContainer';
import ForgotPasswordContainer from './containers/ForgotPasswordContainer';
import ProcessingImages from './containers/ProcessingImages';
import ShortcutsContainer from './containers/ShortcutsContainer';
import TopNavContainer from './containers/TopNavContainer';

export default class App extends Component {
    static propTypes = {
        title: PropTypes.string,
        subtitle: PropTypes.string,
        children: PropTypes.element
    };

    static defaultProps = {
        title: '',
        subtitle: ''
    };

    static contextTypes = {
        router: PropTypes.object.isRequired
    };

    componentDidMount() {
        setupNotificationSystem(this.notificationSystem);
    }

    render() {
        const style = {
            NotificationItem: {
                DefaultStyle: { // Applied to every notification, regardless of the notification level
                    margin: '10px 5px 2px 1px',
                    padding: '10px',
                    fontSize: '120%'
                },
                info: {
                    backgroundColor: '#4285f4',
                    color: 'white'
                }
            }
        };

        const pathname = this.context.router.route.location.pathname;
        const isWorkspace = (startsWith(pathname, '/image') || startsWith(pathname, '/demo/image')) && !startsWith(pathname, '/images');
        const fullHeight = isWorkspace ? {height: '100%'} : null;

        return (
            <div className="app" style={fullHeight}>
                {!isWorkspace && <TopNavContainer/>}
                <ShortcutsContainer/>
                <div className="main" style={fullHeight}>
                    <Route exact path="/" component={Landing}/>
                    <Route path="/demo" exact component={DemoGalleryContainer}/>
                    <Route path="/demo/image/:id" component={DemoImageViewerContainer}/>
                    <PrivateRoute path="/images/:userId" component={MyImagesContainer}/>
                    <Route path="/login" component={Login}/>
                    <Route path="/forgotPassword" component={ForgotPasswordContainer}/>
                    <Route path="/resetPassword" component={ResetPasswordContainer}/>
                    <Route path="/logout" component={Logout}/>
                    <Route path="/register" component={RegisterContainer}/>
                    <Route path="/about" component={About}/>
                    <Route path="/support" component={Support}/>
                    <Route path="/contacts" component={Contacts}/>
                    <Route path="/terms-of-service" component={TermsOfService}/>
                    <Route path="/privacy-policy" component={PrivacyPolicy}/>
                    <PrivateRoute path="/image/:id" component={WorkspaceContainer}/>
                    <PrivateRoute path="/presets" component={PresetsContainer}/>
                    <PrivateRoute path="/preset/:id" component={PresetEditContainer}/>
                    <PrivateRoute exact path="/preset" component={PresetEditContainer}/>
                    <PrivateRoute path="/admin/users" component={UsersContainer}/>
                    <PrivateRoute path="/admin/user/:id" component={UserEditContainer}/>
                    <PrivateRoute exact path="/admin/user" component={UserEditContainer}/>
                    <PrivateRoute path="/profile" component={ProfileContainer}/>
                    <NotificationSystem ref={ c => this.notificationSystem = c } style={style}/>
                    <ProcessingImages/>
                </div>
                {!isWorkspace && <SiteFooter/>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App.js